import { Link } from "wouter";
import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";
import Footer from "@/components/Footer";
import logoW from "@assets/W_1771840384312.webp";

export default function NotFound() {
  const { language, localePath } = useLanguage();
  const nl = language === "nl";

  return (
    <div className="min-h-screen bg-[#0B1A0F] text-white flex flex-col">
      <div className="flex-1 flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(76,234,172,0.06),transparent_70%)] pointer-events-none" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#4CEAAC]/[0.03] blur-[100px] pointer-events-none" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="relative z-10 text-center px-6 max-w-xl"
        >
          <motion.img
            src={logoW}
            alt="Wrkt"
            className="h-12 mx-auto mb-8 opacity-30"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.3, scale: 1 }}
            transition={{ delay: 0.2 }}
          />

          <div className="text-[120px] sm:text-[160px] font-display font-black leading-none tracking-tight bg-gradient-to-b from-white/90 to-white/20 bg-clip-text text-transparent" data-testid="text-404">
            404
          </div>

          <h1 className="text-xl sm:text-2xl font-display font-semibold mt-4 mb-3 text-white/90" data-testid="text-404-title">
            {nl ? "Deze pagina bestaat niet" : "This page doesn't exist"}
          </h1>

          <p className="text-white/50 text-base leading-relaxed mb-10 max-w-sm mx-auto" data-testid="text-404-description">
            {nl
              ? "De pagina die je zoekt is verplaatst, verwijderd of heeft nooit bestaan."
              : "The page you're looking for has been moved, removed, or never existed."}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              href={localePath("/")}
              className="btn btn--mint"
              data-testid="link-home"
            >
              {nl ? "Naar homepage" : "Go to homepage"}
            </Link>
            <Link
              href={localePath("/contact")}
              className="btn btn--outline"
              data-testid="link-contact"
            >
              {nl ? "Neem contact op" : "Get in touch"}
            </Link>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}
